import axios from 'axios'
import {TEMEDA_URI} from 'common/constants'

// 👇️ export the axios instance
export const netAPIInstance = axios.create({
  baseURL: TEMEDA_URI + 'netapi/v1',
})
